import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

export default function AuthCallback() {
  const navigate = useNavigate();
  const { setUser, checkAuth } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = window.location.hash;
    const m = hash.match(/session_id=([^&]+)/);
    if (!m) {
      navigate("/", { replace: true });
      return;
    }
    const sessionId = m[1];

    (async () => {
      try {
        const res = await api.post("/auth/session", { session_id: sessionId });
        // Store session token as fallback (cookies may be blocked in iframe)
        // We didn't return it, but cookie should be set. Also call /auth/me again
        await checkAuth();
        // Clear hash
        window.history.replaceState(null, "", window.location.pathname);
        const next = res.data?.user?.onboarding_complete ? "/app/today" : "/onboarding/language";
        navigate(next, { replace: true });
      } catch (e) {
        console.error("Auth failed", e);
        navigate("/", { replace: true });
      }
    })();
  }, [navigate, setUser, checkAuth]);

  return (
    <div className="min-h-screen flex items-center justify-center" style={{ backgroundColor: "var(--vedari-cream)" }}>
      <div className="text-body animate-soft-pulse" style={{ color: "var(--vedari-ink-soft)" }}>
        Opening your journey…
      </div>
    </div>
  );
}
